import React from 'react';
import { useNavigate } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { buildRoute } from '../utils';
import TwitterSvg from './TwitterSvg';

export default function FooterStatic() {
    const navigate = useNavigate();
    const openLink = url => window.open(url, '_blank');

    const handleClick = (e, slug) => {
        e.preventDefault();
        navigate(buildRoute(`/content/${slug}`))
    };

    return (
        <Box
            sx={(theme) => ({
                p: { xs: '2rem 0.5rem 1rem 0.5rem', sm: '2rem 1rem 1rem 1rem', md: '2rem 2rem 1rem 2rem' },
                pt: 0,
                background: `linear-gradient(90deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.light} 100%)`,
                borderRadius: '2rem 2rem 0 0',
                color: '#fff',
                boxShadow: '0 -4px 24px 0 rgba(31, 38, 135, 0.10)',
                marginTop: '2rem',
                width: '100%',
                a: { color: '#fff !important' },
            })}
        >
            <Box
                sx={(theme) => ({
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(4, 1fr)'
                    },
                    gap: { xs: '2rem', sm: '1.5rem' },
                    width: '100%',
                    alignItems: 'flex-start',
                })}
            >
                {/* Social Icons */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'flex-start', sm: 'flex-start' }, gap: '1rem' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#fff' }}>Connect</Typography>
                    <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <FacebookIcon sx={{ color: '#4267B2', fontSize: 28, cursor: 'pointer' }} onClick={() => openLink('https://facebook.com/100070143116463/')} />
                        <Box sx={{ lineHeight: '.625rem', cursor: 'pointer' }} onClick={() => openLink('https://x.com/MediRadar')}><TwitterSvg /></Box>
                        <LinkedInIcon sx={{ color: '#0077b5', fontSize: 28, cursor: 'pointer' }} onClick={() => openLink('https://www.linkedin.com/in/mediradar/')} />
                        <YouTubeIcon sx={{ color: '#FF0000', fontSize: 28, cursor: 'pointer' }} onClick={() => openLink('https://www.youtube.com/channel/UCXfUWJvHJIrIi-5MloxpNnA')} />
                    </Box>
                </Box>

                {/* About/Info Links */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#fff' }}>About</Typography>
                    <Link href="#" onClick={e => handleClick(e, 'aboutus')}>About us</Link>
                    <Link href="#" onClick={e => handleClick(e, 'aboutscans')}>About scans</Link>
                    <Link href="#" onClick={e => handleClick(e, 'privacyConfidentiality')}>Privacy and Confidentiality</Link>
                    <Link href="#" onClick={e => handleClick(e, 'faqs')}>FAQ</Link>
                </Box>

                {/* Policy/Legal Links */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#fff' }}>Policies</Typography>
                    <Link href="#" onClick={e => handleClick(e, 'cookiepolicy')}>Cookie Policy</Link>
                    <Link href="#" onClick={e => handleClick(e, 'refundtermsinsurance')}>Refund Terms and Insurance</Link>
                    <Link href="#" onClick={e => handleClick(e, 'complaintfeedback')}>Complaints and Feedback</Link>
                    <Link href="#" onClick={e => handleClick(e, 'termsandconditions')}>Terms and Conditions</Link>
                </Box>

                {/* Contact */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#fff' }}>Contact</Typography>
                    <Link href="mailto:info@mediradar.com?subject=Contact us&body=Please leave your name, phone number and brief enquiry and our team will get back to you at the earliest opportunity.">Contact us</Link>
                </Box>
            </Box>
            <Box sx={{ mt: { xs: '2rem', sm: '2.5rem' }, textAlign: 'center', width: '100%' }}>
                <Typography variant='body2' sx={{ color: '#fff', fontWeight: 'bold', fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                    Ⓒ {(new Date()).getFullYear()} MediRadar. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
}